export default __webpack_public_path__ + "static/media/keto-collagen-car.0a3aa817.svg";